/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  const SymbolItem = ({imagePath}) => {
    const imageStyle = {
      width: '100%',
      height: '100%',
    }

    return (
      <div className='symbol symbol-img' style={{flex: '0 0 20%', padding: '10px'}}>
        <img src={imagePath} alt='' srcSet='' style={imageStyle} />
      </div>
    )
  }

  const SymbolGroup = () => {
    return (
      <div
        className='row symbol-group '
        style={{display: 'flex', justifyContent: 'center', flexWrap: 'wrap'}}
      >
        <SymbolItem imagePath='https://iotfyedu.com/assets/images/ecosystem/1x/science_lab.png' />
        <SymbolItem imagePath='https://iotfyedu.com/assets/images/ecosystem/1x/sense_miner.png' />
        <SymbolItem imagePath='https://iotfyedu.com/assets/images/ecosystem/1x/lms.png' />
        <SymbolItem imagePath='https://iotfyedu.com/assets/images/ecosystem/1x/scenario_db.png' />
        <SymbolItem imagePath='https://iotfyedu.com/assets/images/ecosystem/1x/content.png' />
      </div>
    )
  }

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
      {/* begin::Body */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          {/* begin::Wrapper */}
          <div className='w-lg-500px p-10'>
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}

        {/* begin::Footer }
        <div className='d-flex flex-center flex-wrap px-5'>
          {/* begin::Links/}
          <div className='d-flex fw-semibold text-primary fs-base'>
            <a href='#' className='px-5' target='_blank'>
              Terms
            </a>

            <a href='#' className='px-5' target='_blank'>
              Plans
            </a>

            <a href='#' className='px-5' target='_blank'>
              Contact Us
            </a>
          </div>
          { end::Links }
        </div>
        { end::Footer */}
      </div>
      {/* end::Body */}

      {/* begin::Aside */}
      <div
        className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2 '
        // style={{backgroundImage: `url(${toAbsoluteUrl('/media/misc/auth-bg.png')})`}}
        style={{backgroundImage: `url(${toAbsoluteUrl('/media/misc/bg.png')})`}}
      >
        {/* begin::Content */}
        <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100 align-items-center'>
          {/* begin::Logo}
          <Link to='/' className='mb-16'>
            <img alt='Logo' src={toAbsoluteUrl('/media/logos/light.svg')} className='h-75px' />
          </Link>
          { end::Logo */}

          {/* begin::Image }

          <img alt='Logo' src={toAbsoluteUrl('/media/auth/lmsLogin2.png')} className='w-75' />

          {/* end::Image }

          {/* begin::Text }
          <div className='col-lg-7 mt-12'>
            <div
              className='section-title section-center sal-animate'
              data-sal-delay='150'
              data-sal='slide-up'
              data-sal-duration='800'
            >
              <h1 className='display-6 text-center text-white'>Learning Management System</h1>
              <p className='text-secondary text-center mt-4 fs-5'>
                The IOTfyEdu.com online learning platform will be an arena for teachers who want to
                demonstrate their teaching skills beyond the walls of a classroom to their local
                region, country or the world.
              </p>
            </div>
          </div>
           end::Text */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::Aside */}
    </div>
  )
}

export {AuthLayout}
